import React from 'react';
import { css } from '@emotion/react';
import tw from 'twin.macro';

type RadioButtonFC = React.FC<{
  className?: string;
  size?: number;
  choosingColor?: string;
  id?: string;
}> & {
  Option: React.FC<RadioButtonOptionProps>;
};

const RadioButton: RadioButtonFC = ({ size = 18, choosingColor, className, id }) => {
  const isChoosingColor = Boolean(choosingColor);
  choosingColor = choosingColor ?? '#fff';

  return (
    <div
      className={`radio ${className}`}
      id={id}
      css={css`
        ${tw`border border-gray-1 shadow`}
        border-radius: 100%;
        position: relative;
        min-width: ${size}px;
        min-height: ${size}px;
        width: ${size}px;
        height: ${size}px;

        inset: 0px;
        background: url('data:image/svg+xml, <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"><rect fill="white" x="0" width="10" height="10" /><rect x="5" width="5" height="5" fill-opacity="0.15"/><rect fill-opacity="0.15" y="5" width="5" height="5" /></svg>')
          center center;

        &:before {
          border-radius: 100%;
          border: 2px solid #fff;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          background: ${choosingColor};
          width: 100%;
          height: 100%;
        }

        &:after {
          position: relative;
          border-radius: 100%;
          content: '';
          position: absolute;
          ${isChoosingColor
            ? `
            top: ${Math.floor(size / 3 - 1)}px;
            left: ${Math.floor(size / 3 - 1)}px;
            min-width: ${Math.floor(size / 3 + 1)}px;
            min-height: ${Math.floor(size / 3 + 1)}px;
            width: ${Math.floor(size / 3 + 1)}px;
            height: ${Math.floor(size / 3 + 1)}px;
            `
            : `
            top: 2px;
            left: 2px;
            width: ${size - 6}px;
            height: ${size - 6}px;
          `}
        }

        *:checked + &:after {
          background: ${isChoosingColor ? '#fff' : '#39a1b2'};
        }
      `}
    />
  );
};

export interface RadioButtonOptionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  checked?: boolean;
  disabled?: boolean;
  className?: string;

  onChange?: (value: any) => void;
  id?: string;
}

RadioButton.Option = (props): JSX.Element | null => (
  <input
    css={css`
      margin-left: 1rem;
      ${tw`hidden`}

      &:not(:checked) ~ * {
        ${tw`text-color-setting`}
      }
    `}
    type='radio'
    {...props}
  />
);

export default RadioButton;
